<template>
    <div id="bottomLeft">
        <div class="">
            <div class="d-flex pt-2 pl-2">
                <span style="color:#5cd9e8">
                  <icon name="chart-bar"></icon>
                </span>
                <div class="d-flex">
                    <span class="fs-xl text mx-2"></span>
                    <dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />

                </div>
            </div>
            <div>
                <div id="word" style="width:3rem;height:2.8rem"></div>

            </div>
        </div>
    </div>
</template>
<script>
  import echartMixins from "@/utils/resizeMixins";
  export default {
    data() {
      return {
        chart: null,
      };
    },
    mixins: [echartMixins],
    props: {
      word: {
        type: Array
      },
      maskImage: {
        type: HTMLImageElement
      }
    },
    mounted() {
      this.draw();
    },
    methods: {
      draw() {
        // 基于准备好的dom，初始化echarts实例
        this.chart = this.$echarts.init(document.getElementById("word"));

        let option = {
          // tooltip: {},
          series: [ {
            type: 'wordCloud',
            // shape: 'circle',
            // shape: 'diamond',
            // left: 'center',
            // top: 'center',
            right: null,
            bottom: null,
            width: '90%',
            height: '90%',
            // sizeRange: [6, 60],
            sizeRange: [10, 20],//画布范围，如果设置太大会出现少词（溢出屏幕）
            // rotationRange: [-45, 90],
            rotationRange: [-45, 90],//数据翻转范围
            rotationStep: 45,
            gridSize: 5,
            drawOutOfBound: false,
            maskImage: this.maskImage,
            autoSize: {
              enable: true,
              minSize: 6
            },
            textStyle: {
              color: function () {
                return 'rgb(' + [
                  Math.round(Math.random() * 255),
                  Math.round(Math.random() * 255),
                  Math.round(Math.random() * 255)
                ].join(',') + ')';
              }
            },
            emphasis: {
              textStyle: {
                shadowBlur: 10,
                shadowColor: '#333'
              }
            },
            data: this.word
          } ]
        };


        this.chart.setOption(option);
      }
    },
    destroyed() {
      window.onresize = null;
    }
  };
</script>

<style lang="scss">
    #bottomLeft {
        padding: 0.3rem 0.2rem;
        height: 3.5rem;
        min-width: 1.75rem;
        border-radius: 0.0625rem;
        .bg-color-black {
            height: 3rem;
            border-radius: 0.125rem;
        }
        .text {
            color: #c3cbde;
        }
        .chart-box {
            margin-top: 0.2rem;
            width: 1.125rem;
            height: 2.125rem;
            .active-ring-name {
                padding-top: 0.125rem;
            }
        }
    }
</style>
